import React, { useContext, useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios"; // Import Axios
import sendSvg from "../../images/Send.svg";
import { MarktingContext } from "../../Context/MarktingContext";
import { useNavigate } from "react-router-dom";
import Resolved from "./Resolved";
import css from "./style.module.css";
import { AnimatePresence, motion } from "framer-motion";
import AgeDisplay from "./AgeDisplay";

export default function CommentReplyInput({ comentId, loginToken, resolvedStatus, resolvedBy, resolvedAt, archived }) {


    const { setMarktingData, marktingData, userTeam } = useContext(MarktingContext);
    const [reply, setReply] = useState(false);
    const [animationPlayed, setAnimationPlayed] = useState(false);


    const navigation = useNavigate();
    // Yup validation schema
    const validationSchema = Yup.object().shape({
        comment: Yup.string()
            .trim()
            .required("Comment cannot be empty"),
    });

    // API Call Function
    const submitComment = async (comment) => {
        try {
            const payload = {
                commentReplay: comment,
            };
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/comment/replay/${comentId}`, payload, {
                headers: {
                    Authorization: `Bearer ${loginToken}`,
                },

            });

            if (res.status === 200) {
                const deepCopy = [...marktingData]; // Create a deep copy

                const element = deepCopy.find((item) =>
                    item?.Comments.some(comment => comment.id === comentId) ||
                    item?.version?.some(version => version?.Comments.some(comment => comment.id === comentId))
                );

                if (element) {
                    // Update the comment in the maresolvedStatusin Comments array
                    const commentIndex = element.Comments.findIndex(comment => comment.id === comentId);

                    if (commentIndex !== -1) {

                        element.Comments[commentIndex].commentsReplay ? element.Comments[commentIndex].commentsReplay.push(res.data.data) :
                            element.Comments[commentIndex].commentsReplay = [res.data.data];
                    } else {
                        // If not found in main Comments, search in version Comments
                        element.version.forEach(version => {
                            const versionCommentIndex = version.Comments.findIndex(comment => comment.id === comentId);
                            if (versionCommentIndex !== -1) {
                                version.Comments[versionCommentIndex].commentsReplay ? version.Comments[versionCommentIndex].commentsReplay.push(res.data.data) :
                                    version.Comments[versionCommentIndex].commentsReplay = [res.data.data];
                            }
                        });
                    }
                    setMarktingData(deepCopy);
                }
            }

            // return response.data;
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("Firebase Auth");
                localStorage.removeItem("okta-token-storage");
                localStorage.removeItem("okta-cache-storage");
                navigation('/');
                // console.error("seassion expired");
                return;
            };
            // console.error("Error submitting comment:", error.response?.data || error.message);
            throw error;
        }
    };

    return (
        <>
            {!resolvedStatus ? (
                <div className="d-flex flex-wrap align-items-center gap-2 mb-2">
                    <button
                        className="btn d-flex align-items-center gap-2 px-3 rounded-3 shadow-sm bg-light bg-white"
                        style={{
                            padding: "9.8px",
                            fontSize: '0.9rem',
                            border: '1px solid #B3B3B3',
                            color: 'rgba(0, 0, 0, 1)',
                            whiteSpace: 'nowrap',
                            minWidth: 'fit-content'
                        }}
                        onClick={() => setReply(!reply)}>
                        <span style={{ fontWeight: '500' }}>Reply</span>
                    </button>
                    {(userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") && (
                        <Resolved archived={archived} resolvedStatus={resolvedStatus} loginToken={loginToken} comentId={comentId} />
                    )}
                </div>
            ) : ""}
            <div className={`d-flex ${!archived && (userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") ? "justify-content-between" : "justify-content-end"}  align-items-center mb-2 `}>
                {resolvedStatus ? <>
                    {!archived && (userTeam === "compliance" || userTeam === "admin" || userTeam === "superAdmin") ? <Resolved archived={archived} resolvedStatus={resolvedStatus} loginToken={loginToken} comentId={comentId} /> : ""}
                    <span className={css.commentSeeMore} onClick={() => setAnimationPlayed(prev => !prev)}>
                        <motion.span

                            transition={{ duration: 0.3, ease: 'easeInOut' }}
                            style={{ display: 'inline-block', cursor: 'pointer' }}
                        >
                            {animationPlayed ? <i className="fa-solid fa-minus"></i> : <i className="fa-solid fa-plus"></i>}

                        </motion.span>
                    </span>
                </> : ""}
            </div>
            {resolvedStatus &&
                < AnimatePresence mode="wait">
                    {animationPlayed && (
                        <motion.div
                            initial={{ height: 0, opacity: 0, overflow: "hidden" }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{
                                height: { duration: 0.3, ease: "easeInOut" },
                                opacity: { duration: 0.3, ease: "easeInOut" },
                                delayChildren: 0.3,
                                staggerChildren: 0.1,
                            }}
                            className="mb-2 text-muted fw-semibold"
                            style={{ fontSize: "0.9rem" }}
                        >
                            Resolved by {resolvedBy} • {resolvedAt && <AgeDisplay createdAt={resolvedAt} />}
                        </motion.div>
                    )}
                </AnimatePresence >
            }
            {
                reply && (
                    <Formik
                        initialValues={{ comment: "" }}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { resetForm }) => {
                            try {
                                await submitComment(values.comment);
                                resetForm(); // Clear input after successful submission
                            } catch (error) {
                                alert("Failed to submit comment. Try again.");
                            }
                        }}
                    >
                        {({ handleSubmit }) => (
                            <Form onSubmit={handleSubmit}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div style={{ width: "90%" }}>
                                        <Field
                                            as="textarea"
                                            name="comment"
                                            className="my-2 me-2 form-control bg-transparent"
                                            placeholder="Add a Comment"
                                            style={{
                                                width: "100%",
                                                resize: "none",
                                                overflowWrap: "break-word",
                                                wordBreak: "break-word",
                                                minHeight: "40px",
                                                height: "40px",
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter" && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSubmit();
                                                }
                                            }}
                                        />

                                    </div>

                                    <div
                                        onClick={handleSubmit} // Call your submit function here
                                        style={{
                                            width: "35px",
                                            height: "35px",
                                            borderRadius: "50%",
                                            border: "none",
                                            background: "transparent",
                                            cursor: "pointer", // Makes it behave more like a button
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        }}
                                        className="shadow-sm ms-2 holdCursor"
                                    >
                                        <img src={sendSvg} style={{ width: "90%" }} alt="Send" />
                                    </div>
                                </div>
                                <ErrorMessage name="comment" component="div" className="text-danger small" />
                            </Form>
                        )}
                    </Formik>
                )
            }
        </>
    );
}
